import { render, staticRenderFns } from "./AddParameters.vue?vue&type=template&id=77f0ae34"
import script from "./AddParameters.vue?vue&type=script&lang=js"
export * from "./AddParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports